export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11305.76d527bc.jpg";